export default "__VITE_ASSET__768cb4b1__"